import { TDeviceType } from '../../../../node/repositories/header-frontend/v3/get-header-microfrontend';
import { resetTerms } from '../../../../packages/JsonQuery';
import { selectIsModalOpen } from '../../selectors/listingModal';
import { selectNonGeoJsonQuery } from '../../selectors/nonGeoParameters';
import { selectQueryString } from '../../selectors/queryString';
import { selectResultsJsonQuery } from '../../selectors/results';
import { ITypedReduxAction, TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { justChangeJsonQuery } from '../filters/justChangeJsonQuery';
import { resetRegion } from '../region';
import { trackNonGeoSearch } from './tracking';
import { fetchHybridSearchData } from '../fetchHybridSearchData';

export enum ENonGeoParametersActionTypes {
  Set = 'nonGeoParameters/setHasNonGeoParametersSet',
}

type TNonGeoParameters = ITypedReduxAction<ENonGeoParametersActionTypes.Set, boolean>;
export const setNonGeoParameters = actionGenerator<ENonGeoParametersActionTypes.Set, boolean>(
  ENonGeoParametersActionTypes.Set,
);

interface IProps {
  deviceType: TDeviceType;
}

export const searchWithNonGeoParameters =
  ({ deviceType }: IProps): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();
    const nonGeoJsonQuery = selectNonGeoJsonQuery(state);
    const queryString = selectQueryString(state);
    const isListingModalOpen = selectIsModalOpen(state);
    const jsonQuery = selectResultsJsonQuery(state);

    if (!nonGeoJsonQuery) {
      return;
    }

    trackNonGeoSearch({
      queryString,
      jsonQuery,
      pageType: isListingModalOpen ? 'Listing' : 'Map',
    });

    const nextJsonQuery = resetTerms(['bbox', 'id'])(nonGeoJsonQuery);

    dispatch(justChangeJsonQuery({ nextJsonQuery }));
    await dispatch(fetchHybridSearchData({ deviceType }));
    dispatch(setNonGeoParameters(true));
    dispatch(resetRegion());
  };

export type TNonGeoParametersActions = TNonGeoParameters;
